import React, { memo } from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import styles from "./Footer.module.scss";

import { PageWrapper } from "components";

const Footer = () => {
  const router = useRouter();

  const mirQuestLinks = [
    {
      name: "sokrovische-drakona",
      link: "https://mir-kvestov.by/quests/topkvest-sokrovische-drakona",
    },
    {
      name: "missiya-nevypolnima-kartel",
      link: "https://mir-kvestov.by/quests/funquest-cartel",
    },
    {
      name: "zapretnaya-zona-zov-pripyati",
      link: "https://mir-kvestov.by/quests/old-mouse-zapretnaya-zona",
    },
    {
      name: "tehasskaya-reznya-benzopiloy",
      link: "https://mir-kvestov.by/quests/cinema-quest-texas",
    },
    {
      name: "garri-potter-krestrazh",
      link: "https://mir-kvestov.by/quests/topkvest-krestrazh",
    },
    {
      name: "molchanie-yagnyat",
      link: "https://mir-kvestov.by/quests/old-mouse-molchanie-jagnjat",
    },
    {
      name: "sinister-zloveschiy",
      link: "https://mir-kvestov.by/quests/quest-zone-sinister",
    },
    {
      name: "amerikanskaya-istoriya-uzhasov",
      link: "https://mir-kvestov.by/quests/quest-zone-amerikanskaja-istorija-uzhasov",
    },
    {
      name: "tayny-inkvizicii",
      link: "https://mir-kvestov.by/quests/old-mouse-gnev-inkvizicii",
    },
    {
      name: "resident-evil-obitel-zla",
      link: "https://mir-kvestov.by/quests/corvus-resident-evil",
    },
    { name: "zvonok", link: "https://mir-kvestov.by/quests/old-mouse-zvonok" },
  ];
  const singleRout = mirQuestLinks.filter(
    (item) => item?.name === router?.query?.quizId
  )?.[0]?.link;

  const icons = [
    {
      src: "/contactsIcons/instagram.svg",
      href: "https://www.instagram.com/oldmouse.by",
      alt: "Insta logo",
      width: 42,
      height: 42,
      visible: true,
    },
    {
      src: "/contactsIcons/tiktok.svg",
      href: "https://www.tiktok.com/@questminsk",
      alt: "TT logo",
      width: 42,
      height: 42,
      visible: true,
    },
    {
      src: "/contactsIcons/vk.svg",
      href: "https://vk.com/oldmouseminsk",
      alt: "VK logo",
      width: 42,
      height: 42,
      visible: true,
    }
  ];

  const rightInfoMenu = [
    { name: "+375 (44) 771-09-40", href: "tel:+375447710940" },
    { name: "Политика конфиденциальности", href: "/privacy-policy" },
  ];

  return (
    <div className={styles.FooterWrapper}>
      <PageWrapper>
        <div className={styles.FooterContainer}>
          <div className="flex flex-col items-start flex-shrink-0">
            <p className={styles.FooterText}>
              ООО "ОЛД МАУС" УНП 193663622 Old Mouse
            </p>
            <p className={styles.FooterTextSecond}>
              <Link href={"/polzovatelskoe-soglashenie"} scroll={true}>
                <a className={"hover:underline"}>Пользовательское соглашение</a>
              </Link>
            </p>
            <p className={styles.FooterTextSecond}>
              <Link href={"/privacy-policy"} scroll={true}>
                <a className={"hover:underline"}>Политика конфиденциальности</a>
              </Link>
            </p>
          </div>

          <div className="flex flex-row justify-end items-center flex-shrink-0 sm:mt-6">
            {icons.map(
              (item) =>
                item?.visible && (
                  <Link href={item.href} key={item.src}>
                    <a className={styles.ImageIcon}>
                      <Image
                        src={item.src}
                        alt={item.alt}
                        width={item.width}
                        height={item.height}
                      />
                    </a>
                  </Link>
                )
            )}
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};

export default memo(Footer);
